<template>
	<div class='credit-card-info'>
		<h6 class='sub-header primary-color'>{{getText('FinancingDetails')}}</h6>

		<div class="row margin-top-10">
			<div class="col-sm-12 finance-transaction">
				<FormCheckbox @input='update' v-model='accept_terms' :title="getText('FinancingSelect')" />
			</div>
		</div>
		<div class='container margin-top-10' v-if='accept_terms'>
			<div class='row'>
				<div class='col-sm-12'>
					<FormRadio val='1' @input="update" v-model='selected_option' name='instalment' :title="getText('NoFinancing')"/>
				</div>
				<!--<div class='col-sm-10 col-md-11'>
					No financing selected
				</div>-->
			</div>
			<div class='row' v-for='instalment in financing_options().Instalments'>
				<div class='col-sm-12'>
					<FormRadio :val='instalment.Number' @input="update" v-model='selected_option' name='instalment' :title='financeFormatString(instalment)'/>
				</div>
				<!--
				<div class='col-sm-10 col-md-11'>
					Pay <b>{{rateOffer().Symbol}}{{instalment_pay_amount(instalment)}}</b> {{rateOffer().Currency}} over <b>{{instalment.Number}}</b> Months ({{instalment_rate(instalment)}}% Interest)
				</div>-->
			</div>
		</div>
	</div>
</template>

<style lang="scss">
	// global css to override scope label styles
  	.finance-transaction label {
		margin-top: 0 !important;
	}
</style>

<style scoped lang="scss">
	.credit-card-info{
		margin-top: 50px;
		width: 100%;
	}
	.form-input{
		display: inline-block;
	}
	.checkbox-info{
		line-height: 26px;
		display: inline-block;
		vertical-align: top;
		margin-left: 10px;
	}
	.margin-top-10{
		margin-top: 10px;
	}
</style>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

// Language / Localization
import LanguageService from "@/common/language.service";

import FormCheckbox from "@/components/form_elements/FormCheckbox";
import FormRadio from "@/components/form_elements/FormRadio";

import {
	SET_FINANCING_OPTION
} from "@/store/mutations.type";

export default {
	name: "FinancingDetails",
	components: {
		FormCheckbox,
		FormRadio
	},
	props: {
		value: Object
	},
	data(){
		return {
			accept_terms: false,
			selected_option: 1
		};
	},
	beforeMount(){
		// Preset data from store
		if(this.financing_selected().Number !== undefined) {
			this.selected_option = this.financing_selected().Number;
			this.accept_terms = true;
		}
	},
	computed: {
		issuer_item(){
			// If financing not selected or specific number not chosen return {}
			if(!this.accept_terms || this.selected_option == 1) return {};
			// Otherwise, grab the option selected from the list
			return this.financing_options().Instalments.filter(x => x.Number == this.selected_option)[0];
		},
		processing_rate(){
			return this.RATE_processing_fee();
		}
	},
	methods: {
		// Generate dynamic string from text template & values
		financeFormatString(instalment){
			var amount = this.rateOffer().Symbol + this.instalment_pay_amount(instalment) + " " + this.rateOffer().Currency;
			var duration = instalment.Number;
			var interest = this.instalment_rate(instalment);
			return this.getText('FinanceTemplate').format(amount, duration, interest);
		},
		getText(key){
			return LanguageService.getText(key);
		},
		update() {
			// Store the option chosen
			store.commit(SET_FINANCING_OPTION, this.issuer_item);
		},
		instalment_pay_amount: function(instalment){
			// Grab total in customer currency
			var currency_amount = (this.invoice().amount * this.rateOffer().RateOffer.Rate);
			// Add interest fees
			var interest_fees = (currency_amount * instalment.Rate);
			currency_amount = (1*currency_amount)+(1*interest_fees);
			// Add paymenth method fees
			if(this.processing_rate > 0){
				currency_amount += (1* (this.processing_rate*currency_amount));
			}
			// Divide by instalment number
			return currency_amount.toFixed(this.rateOffer().Units);
		},
		instalment_rate: function(instalment){
			return (instalment.Rate * 100).toFixed(this.rateOffer().Units);
		},
		...mapGetters(["financing_selected", "rateOffer", "invoice", "merchant", "fees", "payment_method", "financing_options", "RATE_processing_fee"])
	}
}
</script>
